import { render, staticRenderFns } from "./step4KsCom.vue?vue&type=template&id=02de6ab6&scoped=true"
import script from "./step4KsCom.vue?vue&type=script&lang=js"
export * from "./step4KsCom.vue?vue&type=script&lang=js"
import style0 from "./step4KsCom.vue?vue&type=style&index=0&id=02de6ab6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02de6ab6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/yto-crm-steward-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02de6ab6')) {
      api.createRecord('02de6ab6', component.options)
    } else {
      api.reload('02de6ab6', component.options)
    }
    module.hot.accept("./step4KsCom.vue?vue&type=template&id=02de6ab6&scoped=true", function () {
      api.rerender('02de6ab6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/guidance/steps/step4KsCom.vue"
export default component.exports